import axios from "axios";
import {makerDataUrl, previewDataUrl} from "./url";
import {setVkUserProjects} from "../store/makerDataSlice";

export default async function getVkUserProjectsData(argsData: any) {

    let params = argsData.params;
    let dispatch = argsData.dispatch;
    let makerData = argsData.makerData;

    const getParams = {
        ...params,
    };
    const urlParams = new URLSearchParams(window.location.search);
    const entries = urlParams.entries();
    Array.from(entries).map((entry) => {
        // @ts-ignore
        getParams[entry[0]] = entry[1];
    })
    Object.keys(getParams).forEach(key => {
        // @ts-ignore
        if (getParams[key] === undefined) {
            // @ts-ignore
            delete getParams[key];
        }
    });

    if (makerData?.vkLaunchParams?.vk_app_id) {
        for (const [key, value] of Object.entries(makerData.vkLaunchParams)) {
            getParams[key] = value;
        }
    }

    // @ts-ignore
    getParams['r'] = (new Date()).getTime();

    const response = await axios.get(makerDataUrl, {params: getParams});
    if (response.data.result == 'ok') {
        const backendMakerData = response.data;
        dispatch(setVkUserProjects(backendMakerData?.vkUserProjects));
    } else {
        throw ({
            message: 'Failed to load vk user projects. Wrong response.',
            response: response,
            responseConfig: JSON.stringify(response?.config),
            responseData: JSON.stringify(response?.data),
            url: previewDataUrl
        });
    }
}